import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserDetails, receiveAmount } from "../../actions/userActions";
import { Link, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
import TransactiopnPrint from "./TransactiopnPrint";
import { dateFormat } from "../utils/Utils";

export default function Customer() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [transactions, setTransactions] = useState([]);
  console.log(transactions[0]?.orderId);

  const [orders, setOrders] = useState([]);

  console.log(orders);

  const [amount, setAmount] = useState("");
  const [discount, setDiscount] = useState(0);
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const [selectedOrder, setOrderSelected] = useState("");

  useEffect(() => {
    dispatch(getUserDetails(id));

    getTransactions();
    getOrders();
  }, [dispatch]);

  const getTransactions = async () => {
    await Axios.get(`/api/user/trans/${id}`).then((res) => {
      setTransactions(res.data);
      console.log("tran",res.data);
      
    });
  };

  const getOrders = async () => {
    await Axios.get(`/api/order/myorders/${id}`).then((res) => {
      setOrders(res.data);
    });
  };
  console.log(orders);

  const user_ = useSelector((state) => state.user);
  const { user } = user_;

  console.log(user);

  const getOrderId = (orderId) => {
    let data = orders?.find((data) => data._id === orderId);
    return data.orderId;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    let data = {
      amount: user?.balanceAmount,
      discount,
      receive: amount,
      date,
      note,
      customer: id,
      orderId: selectedOrder,
      order: getOrderId(selectedOrder),
    };

    let data_ = await Axios.post(`/api/user/trans/`, data);
    if (data_) {
      window.location.href = `/user/${id}`;
    }
  };

  // FIX: Calculate the correct order amount from order items
  const getCorrectOrderAmount = (orderId) => {
    // Find the order
    const order = orders?.find((data) => data._id === orderId);

    if (!order || !order.orderItems || order.orderItems.length === 0) {
      return order?.orderAmount || 0;
    }

    // Calculate total from all order items
    const calculatedAmount = order.orderItems.reduce((total, item) => {
      const itemAmount =
        (item.prodPrice || 0) * (item.qnty || 1) * (item.days || 1);
      return total + itemAmount;
    }, 0);

    return calculatedAmount > 0 ? calculatedAmount : order?.orderAmount || 0;
  };

const getCorrectBalance = (transaction) => {
  const order = orders?.find((data) => data._id === transaction.orderId);
  
  if (!order) {
    const correctAmount = getCorrectOrderAmount(transaction.orderId);
    return correctAmount - (transaction.receive || 0) - (transaction.discount || 0);
  }

  const correctAmount = getCorrectOrderAmount(transaction.orderId);
  
  const totalReceived = order.totalReceive || 0;
  const totalDiscount = order.discount || 0;
  
  const correctBalance = correctAmount - totalReceived - totalDiscount;
  
  return correctBalance;
};
  const getTotalCorrectBalance = () => {
    if (!transactions || transactions.length === 0) {
      return 0;
    }

    const totalBalance = transactions.reduce((total, transaction) => {
      const transactionBalance = getCorrectBalance(transaction);
      return total + transactionBalance;
    }, 0);

    return totalBalance;
  };

  // Get the correct total balance
  const correctTotalBalance = getTotalCorrectBalance();
  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="col-md-4 stretch-card grid-margin">
          <div class="card">
            <div class="card-body">
              <p class="card-title">{user?.name}</p>
              <ul class="icon-data-list">
                <li>
                  <div className="p-1 d-flex">
                    <img
                      src={
                        user?.photo === ""
                          ? process.env.PUBLIC_URL + "/images/avt.jpg"
                          : `${user?.photo}`
                      }
                      style={{ height: "120px", width: "70%" }}
                      alt="user"
                    />
                  </div>
                </li>
                <li>
                  <div class="d-flex">
                    <span> Balance : </span>
                    <div>
                      <p class="text-info mb-1 mt-1 ml-3">
                        ₹ {correctTotalBalance}
                      </p>
                    </div>
                  </div>
                </li>
                <div>
                  <p class=" mb-1">Place : {user?.address1}</p>
                  <p class="mb-0">Post : {user?.address2}</p>
                  <p class="mb-0">Pin : {user?.address3}</p>
                  <p class="mb-0">Area : {user?.address4}</p>
                </div>
                <li>
                  <div class="d-flex">
                    <span> Phone : </span>
                    <div>
                      <p class="text-info mb-1 mt-1 ml-3">{user?.phone}</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    {" "}
                    Frontside <b>{user?.id1Name}</b>
                    <a href={user?.id1}>click here </a>
                    <br />
                    Backside:<b> {user?.id1Name}</b>{" "}
                    <a href={user?.id1Sec}> click here </a>
                  </div>
                  <br />
                  <div className="p-2">
                    <img
                      className="adhar-image  "
                      src={
                        user?.id1 === ""
                          ? process.env.PUBLIC_URL + "/images/no_image.png"
                          : `${user?.id1}`
                      }
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="adhar-image  "
                      src={
                        user?.id1Sec === ""
                          ? process.env.PUBLIC_URL + "/images/no_image.png"
                          : `${user?.id1Sec}`
                      }
                    />
                  </div>
                </li>
                <li>
                  <div>
                    {" "}
                    Frontside:<b> {user?.id2name}</b>{" "}
                    <a href={user?.id2}> click here </a>
                    <br />
                    Backside:<b> {user?.id2name}</b>{" "}
                    <a href={user?.id2Sec}> click here </a>
                  </div>
                  <br />
                  <div className="p-2">
                    <img
                      className="adhar-image"
                      src={
                        user?.id2 === ""
                          ? process.env.PUBLIC_URL + "/images/no_image.png"
                          : `${user?.id2}`
                      }
                    />
                  </div>

                  <div className="p-2">
                    <img
                      className="adhar-image"
                      src={
                        user?.id2Sec === ""
                          ? process.env.PUBLIC_URL + "/images/no_image.png"
                          : `${user?.id2Sec}`
                      }
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-8 stretch-card grid-margin">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="mr-auto p-2">
                  {" "}
                  <p class="card-title">Transactions</p>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped table-borderless">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Date</th>
                      <th>Order Id</th>
                      <th>Amount</th>
                      <th>Received</th>
                      <th>Discount</th>
                      <th>Note</th>
                      <th>Balance</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions?.map((data, index) => {
                      // Calculate correct amounts for each transaction
                      const correctAmount = getCorrectOrderAmount(data.orderId);
                      const correctBalance = getCorrectBalance(data);

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{dateFormat(data.createdAt)}</td>

                          <td>
                            {" "}
                            <Link to={`/order/${data.orderId}`}>
                              {" "}
                              ADC_{data?.order}
                            </Link>
                          </td>
                          <td class="font-weight-bold">₹ {correctAmount}</td>
                          <td>₹ {data?.receive}</td>
                          <td>₹ {data?.discount}</td>
                          <td> {data?.note}</td>
                          <td class="font-weight-medium">
                            <div
                              class={
                                correctBalance > 0
                                  ? `badge badge-danger`
                                  : "badge badge-success"
                              }
                            >
                              ₹ {correctBalance}
                            </div>
                          </td>
                          <td>
                            <div className="mt-2">
                              {" "}
                              <PDFDownloadLink
                                document={
                                  <TransactiopnPrint
                                    orderId={data?.order}
                                    cusName={user?.name}
                                    amount={correctAmount}
                                    receive={data?.receive}
                                    discount={data?.discount}
                                    balance={correctBalance}
                                  />
                                }
                                fileName="transaction.pdf"
                              >
                                {({ blob, url, loading, error }) => (
                                  <button type="button" class="btn btn-primary">
                                    print
                                  </button>
                                )}
                              </PDFDownloadLink>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        backdrop={true}
        data-backdrop="static"
      >
        {" "}
        <form class="forms-sample" onSubmit={submitHandler}>
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Receive Amount
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="exampleInputName">Amount</label>
                  <input
                    type="number"
                    class="form-control"
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Amount"
                    value={amount}
                    name="amount"
                    required={true}
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Discount</label>
                  <input
                    type="number"
                    class="form-control"
                    onChange={(e) => setDiscount(e.target.value)}
                    placeholder="Discount"
                    value={discount}
                    name="discount"
                    required={true}
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Date</label>
                  <input
                    type="date"
                    class="form-control"
                    onChange={(e) => setDate(e.target.value)}
                    placeholder="name"
                    value={date || new Date().toISOString().substr(0, 10)}
                    name="date"
                    required={true}
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Note</label>
                  <input
                    type="text"
                    class="form-control"
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Notes"
                    value={note}
                    name="note"
                    required={true}
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputName">Order</label>
                  <select
                    class="form-control"
                    onChange={(e) => setOrderSelected(e.target.value)}
                    value={selectedOrder}
                  >
                    <option value="">Select Order</option>
                    {orders?.map((data) => (
                      <option value={data._id}>ADC_{data.orderId}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" class="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
